import React, { useEffect, useState } from 'react';
import Styles from './styles.module.sass';
import { useHistory } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

import { ModalError } from 'components/Error/ErrorModal'
import { DataCard } from 'pages/Credito/2-AgregarTarjeta/AgregarTarjetaBancaria/DataCard'
import { DirectionCard } from 'pages/Credito/2-AgregarTarjeta/AgregarTarjetaBancaria/DirectionCard'
import { encodeStorage, decodeStorage } from 'functions/storageBase64'
import { postAddCardT1 } from 'services/T1Pagos'
import { usePayCard } from 'hooks/usePayCard'
import Loading from 'components/Loading'
import MainLayout from 'newComponents/Layout/MainLayout';
import CreditoLayout from 'newComponents/Layout/CreaditoLayout';
import SectionLayout from 'newComponents/Layout/SectionLayout';

export default function AgregarTarjetaBancaria() {

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Add Credit Card  Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    const [ data, setData ] = useState()

    const clientT1 = decodeStorage('clientT1')
    const [ loading, setLoading ] = useState(false)
    const {dataPayment, successPay, errorPay} = usePayCard()

    const [titlePage, setTitlePage] = useState()
    const [stepPage, setStepPage] = useState(1)
    const [addCard, setAddCard] = useState({
        cardNumber: "",
        titular: "",
        mes: "",
        anio: "",
        cvc: ""
    })
    const [addDirection, setAddDirection] = useState({
        calle: "",
        numExt: "",
        numInt: "",
        cp: "",
        estado: "",
        municipio: "",
        ciudad: "",
        colonia: ""
    })

    const history = useHistory();
    const payCardRelation = decodeStorage('payCardRelation')

    useEffect(()=>{
        if(!payCardRelation){
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta`);
        }
    },[])

    useEffect(()=>{
        setTitlePage('Agregar tarjeta')
        setStepPage(1)
    },[])

    const [sectionPay, setSectionPay] = useState(false)
    const [responseAddCardT1, setResponseAddCardT1] = useState()
    useEffect(()=>{
        if(sectionPay){
            let addCardT1 = {
                nombre: addCard.titular,
                pan: Number(addCard.cardNumber),
                cvv2: String(addCard.cvc),
                expiracion_mes: parseInt(addCard.mes),
                expiracion_anio: parseInt(addCard.anio),
                direccion: {
                    linea1: String(addDirection.calle).slice(0,120),
                    linea2: String(addDirection.numExt+','+addDirection.numInt).slice(0,120),
                    linea3: String(addDirection.colonia).slice(0,120),
                    cp: String(addDirection.cp),
                    municipio: String(addDirection.municipio),
                    ciudad: String(addDirection.ciudad),
                    estado: String(addDirection.estado),
                    pais: "MEX",
                    referencia_1: "",
                    referencia_2: "",
                    longitud: Number(-90),
                    latitud: Number(-90)
                },
                cliente_id: String(clientT1.id),
                default: true,
                cargo_unico: false
            }
            //console.log('addCardT1: ',addCardT1)
            postAddCardT1(addCardT1)
            .then(setResponseAddCardT1)
        }
    },[sectionPay])
    
    const [errorCode, setErrorCode ] = useState()
    const [messageResponse, setMessageResponse ] = useState()
    const [sectionActive, setSectionActive ] = useState(null)
    const [showModalErr, setShowModalErr] = useState(false);
    useEffect(()=>{
        if(responseAddCardT1){
            setSectionPay(false)
            if(responseAddCardT1.statusCode === 200){
                //console.log('responseAddCardT1', responseAddCardT1.data)
                dataPayment({
                    idCard: responseAddCardT1?.data?.tarjeta?.token,
                    cvv: parseInt(addCard.cvc),
                    payCardRelation: payCardRelation,
                    addCard: responseAddCardT1
                })            
            }else if(responseAddCardT1.statusCode === 400){
                let dataError = JSON.parse(responseAddCardT1.data)
                setLoading(false)
                if(dataError){
                    //console.log(dataError)
                    //console.log(dataError?.data?.errors?.pan[0])
                    setShowModalErr(true)
                    setSectionActive(null)
                    setErrorCode({codMen: dataError?.error?.code})
                    setMessageResponse(dataError?.data?.errors?.pan[0] )
                }
            }
            else if(responseAddCardT1.statusCode === 409){
                let dataError = JSON.parse(responseAddCardT1.data)
                setLoading(false)
                if(dataError){
                    //console.log(dataError)
                    //console.log(dataError?.data?.errors?.pan[0])
                    setShowModalErr(true)
                    setSectionActive(null)
                    setErrorCode({codMen: dataError?.error?.code})
                    setMessageResponse(dataError?.error?.message )
                }
            }
        }
    },[responseAddCardT1])


    // valida pago y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if(sectionActive === 'choiseCards'){
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}elegir-tarjeta`)
        }
    }
    useEffect(()=>{
        if(successPay){
            setLoading(false)
            encodeStorage('payCodeSuccess', successPay)
            history.push(`${BASE_PATH}${SUB_DIRECTORY}thakYouPage`);
        }
        else if(errorPay){
            setLoading(false)
            setShowModalErr(true)
            setErrorCode(errorPay)
            setSectionActive('choiseCards')
            setMessageResponse(errorPay?.message)
        }
    },[successPay, errorPay])


    const clickBackButton = () => {
        if(stepPage === 1){
            history.goBack(-1)
        }
        else if(stepPage === 2){
            setTitlePage('Agregar tarjeta')
            setStepPage(1)
        }
    }

    const nextPage = () => {
        setTitlePage('Dirección de la tarjeta')
        setStepPage(2)
    }

    const paySection = () => {
        setLoading(true)
        setSectionPay(true)
    }
    
    return (
        <MainLayout>
            <CreditoLayout setData={setData} >
                { loading && <Loading /> }
                <SectionLayout title="PAGAR TARJETA" >
                    <div className="contPlanes">

                        {stepPage === 1 &&
                            <DataCard
                            setAddCard={setAddCard}
                            addCard={addCard}
                            nextPage={nextPage}
                            />
                        }

                        {stepPage === 2 && 
                            <DirectionCard
                            setAddDirection={setAddDirection}
                            addDirection={addDirection}
                            nextPage={paySection}
                            action={clickBackButton}
                            setLoading={setLoading}
                            />
                        }

                    </div>
                </SectionLayout>

                {showModalErr &&
                    <ModalError
                        errorCode={errorCode}
                        section={sectionActive}
                        message={messageResponse}
                        handleClose={handleCloseErr}
                    />
                }
            </CreditoLayout>
        </MainLayout>
    )
}